import React, { Component, Fragment } from "react";
import { Carousel, Container, Image } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import idcardPreview from "../../assets/images/download.png";
import support from "../../assets/images/icon-support-small.svg";
import Notification from "../../components/UI/Alerts/Notification/Notification";
import Modal from "../../components/UI/Modal/Modal";
import { logFirebaseEvent } from "../../shared/utility";
import classes from "./IdCard.module.css";

interface IStateFromProps {
  t: any;
}

class IdCard extends Component<IStateFromProps> {
  // fileObj: { key: string; value: File }[] = [];
  userId = localStorage.getItem("userId");
  state = {
    imageFront: localStorage.getItem(
      this.userId + `-imageFront-${process.env.REACT_APP_BUILD_ENVIRONMENT}`
    ),
    imageBack: localStorage.getItem(
      this.userId + `-imageBack-${process.env.REACT_APP_BUILD_ENVIRONMENT}`
    ),
    userId: localStorage.getItem("userId"),
    fileSizeAlert: false,
  };
  getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  };
  dataUrlToFile = async (dataUrl: string, fileName: string): Promise<File> => {
    const res: Response = await fetch(dataUrl);
    const blob: Blob = await res.blob();
    return new File([blob], fileName, { type: "image/png" });
  };
  setFileSizeAlert = () => {
    console.log("fileSizeAlert", true);
    this.setState({ fileSizeAlert: true });
  };
  resetFileSizeAlert = () => {
    console.log("fileSizeAlert", false);
    this.setState({ fileSizeAlert: false });
  };
  saveFiles = async (file: File, index: number) => {
    const fileSize = Math.round(file.size / 1024);
    console.log("fileSize", fileSize);
    if (fileSize >= 2048) {
      console.log("fileSize", fileSize);
      this.setFileSizeAlert();
      return;
    }
    if (index === 0) {
      const imageFrontBase64 = await this.getBase64(file);
      this.setState({ imageFront: imageFrontBase64 });
      console.log(imageFrontBase64);
      localStorage.setItem(
        `${this.userId}-imageFront-${process.env.REACT_APP_BUILD_ENVIRONMENT}`,
        JSON.stringify(imageFrontBase64)
      );
    } else if (index === 1) {
      const imageBackBase64 = await this.getBase64(file);
      this.setState({ imageBack: imageBackBase64 });
      console.log(imageBackBase64);
      localStorage.setItem(
        `${this.userId}-imageBack-${process.env.REACT_APP_BUILD_ENVIRONMENT}`,
        JSON.stringify(imageBackBase64)
      );
    }
  };
  uploadFiles = (e, index) => {
    e.preventDefault();
    console.log("e.target.files[0]", e.target.files[0]);
    this.saveFiles(e.target.files[0], index);
    e.target.value = "";
  };

  loadFiles = async () => {
    const { userId } = this.state;
    if (
      localStorage.getItem(
        `${userId}-imageFront-${process.env.REACT_APP_BUILD_ENVIRONMENT}`
      )
    ) {
      this.setState({
        imageFront: JSON.parse(
          localStorage.getItem(
            `${userId}-imageFront-${process.env.REACT_APP_BUILD_ENVIRONMENT}`
          )!
        ),
      });
    } else {
      this.setState({
        imageFront: "",
      });
    }
    if (
      localStorage.getItem(
        `${userId}-imageBack-${process.env.REACT_APP_BUILD_ENVIRONMENT}`
      )
    ) {
      this.setState({
        imageBack: JSON.parse(
          localStorage.getItem(
            `${userId}-imageBack-${process.env.REACT_APP_BUILD_ENVIRONMENT}`
          )!
        ),
      });
    } else {
      //   this.fileObj[1] = await this.dataUrlToFile(idcardPreview, "imageBack");
      this.setState({
        imageBack: "",
      });
    }
  };

  componentDidMount() {
    logFirebaseEvent("IDCard");
    this.loadFiles();
  }
  deleteBackIdCard = () => {
    const { userId } = this.state;
    localStorage.setItem(
      `${userId}-imageBack-${process.env.REACT_APP_BUILD_ENVIRONMENT}`,
      ""
    );
    this.setState({ imageBack: "" });
  };
  deleteFrontIdCard = () => {
    const { userId } = this.state;
    localStorage.setItem(
      `${userId}-imageFront-${process.env.REACT_APP_BUILD_ENVIRONMENT}`,
      ""
    );
    this.setState({ imageFront: "" });
  };
  render() {
    const { t } = this.props;
    const modalContact = {
      width: "360px",
      left: "calc(50% - 180px)",
    };
    let displayFileSizeAlert: any;
    if (this.state.fileSizeAlert) {
      displayFileSizeAlert = (
        <Modal
          show={this.state.fileSizeAlert}
          childComp={
            <Notification
              modalClosed={this.resetFileSizeAlert}
              notificationText={t("idCard.bigFile")}
            />
          }
          style={modalContact}
        ></Modal>
      );
    }
    return (
      <Fragment>
        {displayFileSizeAlert}
        <Container fluid>
          <div className="inner-banner" id="container">
            <div className="inner-banner-title">
              <h3>{t("idCard.idCardTitle")}</h3>
              <Image
                src={support}
                alt="support"
                data-test="stockIMG"
                style={{ right: 21 }}
              />
            </div>
          </div>
          <div className="mainContainer" style={{ maxWidth: 380 }}>
            <p className="pb-2">{t("idCard.idCardDescription")}</p>
            {/*   {t('idCard.idCardDescription')} */}
            <div className={classes.idCarousel}>
              <Carousel interval={null} className={classes.carousel}>
                <Carousel.Item>
                  <div className={classes.uploadText}>{t("idCard.front")}</div>
                  {/* {t('idCard.front')} */}
                  <div className={classes.uploadBtn}>
                    <label className="btn btn-small text-white">
                      <span className={classes.buttonText}>
                        {this.state.imageFront
                          ? t("idCard.editBtn")
                          : t("idCard.uploadBtn")}
                      </span>
                      <input
                        type="file"
                        className="form-control"
                        onChange={(e) => this.uploadFiles(e, 0)}
                        accept="image/*"
                        hidden
                      />
                    </label>
                  </div>
                  <div className="clear"></div>
                  <div>
                    {!this.state.imageFront && (
                      <span className={classes.imageNotText}>
                        {t("idCard.ImageNotAvailable")}
                      </span>
                    )}
                    <Image
                      src={
                        this.state.imageFront
                          ? this.state.imageFront
                          : idcardPreview
                      }
                      alt={idcardPreview}
                      className={classes.idCard}
                    />
                  </div>

                  {this.state.imageFront && (
                    <div
                      className={classes.closeBtn}
                      onClick={this.deleteFrontIdCard}
                    >
                      X
                    </div>
                  )}
                </Carousel.Item>
                <Carousel.Item>
                  <div className={classes.uploadText}>
                    {t("idCard.backTxt")}
                  </div>
                  {/* {t('idCard.backTxt')} */}
                  <div className={classes.uploadBtn}>
                    <label className="btn btn-small text-white">
                      <span className={classes.buttonText}>
                        {this.state.imageBack
                          ? t("idCard.editBtn")
                          : t("idCard.uploadBtn")}
                      </span>
                      <input
                        type="file"
                        className="form-control"
                        onChange={(e) => this.uploadFiles(e, 1)}
                        accept="image/*"
                        hidden
                      />
                    </label>
                  </div>
                  <div className="clear"></div>
                  <div>
                    {!this.state.imageBack && (
                      <span className={classes.imageNotText}>
                        {t("idCard.ImageNotAvailable")}
                      </span>
                    )}
                    <Image
                      src={
                        this.state.imageBack
                          ? this.state.imageBack
                          : idcardPreview
                      }
                      alt={idcardPreview}
                      className={classes.idCard}
                    />
                  </div>
                  {this.state.imageBack && (
                    <div
                      className={classes.closeBtn}
                      onClick={this.deleteBackIdCard}
                    >
                      X
                    </div>
                  )}
                </Carousel.Item>
              </Carousel>
            </div>
          </div>
        </Container>
      </Fragment>
    );
  }
}

// export default IdCard;
export default withTranslation()(IdCard);
